function FooterComponent() {
  return <></>;
}

export default FooterComponent;
